import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tabs, Tab, Box ,Grid} from '@mui/material';
import { makeStyles } from '@material-ui/core';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import MainContainer from '../../../components/MainContainer';
import MissionSummaryService from '../../../services/MissionSummaryService';
import MissionTransportService from '../../../services/MissionTransportService';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import { headerData } from '../../../data/modules/my-validations-header';
import IndemnityMissionConfirm from './IndemityMissionConfirm';
import FuelProvisionalConfirm from './FuelProvisionalConfirm';

const useStyles = makeStyles((theme) => ({
  paper: {
    boxSizing: "border-box",
    padding: theme.spacing(2),
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    elevation: 2,
    fontSize: "12px",
    borderRadius: "8px !important",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowY: "auto",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
  },
  tab: {
    width: "50%",
    minHeight: "46px !important",
    borderRadius: "8px !important",
    color: "#526581 !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    lineHeight: "1.3 !important",
    letterSpacing: "0.1px !important",
    textTransform: "none !important",
    transition: "background-color 180ms ease, color 180ms ease, box-shadow 180ms ease !important",
    "&:hover": {
      backgroundColor: "#eaf2ff",
      color: "#1976d2 !important",
    },
    "&.Mui-selected": {
      backgroundColor: "#1976d2",
      color: "#ffffff !important",
      boxShadow: "0 4px 10px rgba(25, 118, 210, 0.24)",
    },
    "&.Mui-focusVisible": {
      outline: "3px solid rgba(25, 118, 210, 0.25)",
      outlineOffset: "2px",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "52px !important",
      padding: "8px !important",
      fontSize: "12px !important",
    },
  },
  tabs: {
    minHeight: "46px !important",
    "& .MuiTabs-flexContainer": {
      gap: theme.spacing(1),
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  tabsContainer: {
    backgroundColor: "#f4f7fb",
    border: "1px solid #dce6f3",
    borderRadius: "10px",
    // padding: theme.spacing(0.75),
    marginBottom: theme.spacing(2),
    boxShadow: "0 3px 10px rgba(15, 23, 42, 0.06)",
  },
  tabPanel: {
    padding: theme.spacing(2, 0),
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
  },
  fieldset: {
    boxSizing: "border-box",
    borderRadius: "10px",
    color: "#1976d2",
    fontSize: "20px",
    marginTop: "10px",
    overflow: "hidden",
    padding: "10px",
    maxWidth: "100%",
    minWidth: 0,
    width: "100%",
    border: "1px solid #d7e1f3",
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 200,
      letterSpacing: "0.2px",
    },
  },
}));

const FuelMissionConfirm = ({ mode = 'mission' }) => {
  const { mission_planning_id, timesheet_id, agenda_id} = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);


  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  
  const { open, color, messageInfo } = message;

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };



  const renderTabContent = () => {
    switch (tabValue) {
      case 0:
        return (
          <div className={classes.tabPanel}>
            <fieldset className={classes.fieldset}>
              <legend>Carburant prévisionnel de mission</legend>
              <FuelProvisionalConfirm />
            </fieldset>
          </div>
        );
      case 1:
        return (
          <div className={classes.tabPanel}>
            <fieldset className={classes.fieldset}>
              <legend>Indemnité de mission</legend>
              <Grid container spacing={3}>
                 <Grid item xs={12}>
                      <IndemnityMissionConfirm missionid={mission_planning_id} timesheet_id={timesheet_id}/>
                 </Grid>
              </Grid>
            </fieldset>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <MainContainer {...headerData}>
      <LoadingSimpleBackdrop open={loadingBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} onClose={handleCloseMessage} />
      
      <div className={classes.paper}>
        <Box className={classes.tabsContainer}>
          <Tabs
            className={classes.tabs}
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="mission tabs"
          >
            <Tab label="Carburant prévisionnel de mission" className={classes.tab} />
            <Tab label="Indemnité de mission" className={classes.tab} />
          </Tabs>
        </Box>

        {renderTabContent()}
      </div>
    </MainContainer>
  );
};

export default FuelMissionConfirm;

